import { ButtonBase, Collapse, Icon, TextField } from '@material-ui/core';
import React, { useState } from 'react';

import styles from './styles';

interface IProps {
  handleTokenApi: (tokenApi: string) => void;
  loading: boolean;
  tokenApi: string;
  classes?: any;
}

function ApiTokenForm({ handleTokenApi, tokenApi, loading, classes }: IProps) {
  const [hasToken, setHasToken] = useState(false);

  return (
    <>
      <ButtonBase className={classes.expand} onClick={() => setHasToken(!hasToken)}>
        {'Configurações de API de Conversões  '}
        {hasToken ? <Icon fontSize='inherit'>expand_less</Icon> : <Icon fontSize='inherit'>expand_more</Icon>}
      </ButtonBase>
      <Collapse in={hasToken}>
        <div className='m8' />

        <div className='m8' />
        <p className={classes.font}>Token API de Conversão</p>
        <TextField disabled={loading} value={tokenApi} className={classes.domainInput} onChange={(e: any) => handleTokenApi(e.target.value)} />
        <div className='m8' />
        <p className={classes.customMessage}>
          Dentro das configurações do seu Pixel do Facebok, vá na aba <b>Configurações</b> e em <b>API de Conversões</b>, dentro da sessão{' '}
          <b>Configurar Manualmente</b>, clique em <b>Gerar Token de Acesso</b>.
        </p>
      </Collapse>
    </>
  );
}

export default React.memo(styles(ApiTokenForm));
